export type CustomerItemData = {
  "@id": string;
  "@type": string;
  id: number;
  name: string;
  address: string;
  reference: string;
};

export type CustomerPagination = {
  "@id": string;
  type: string;
  first: string;
  last: string;
  previous: string;
  next: string;
};

export type CustomerSearchMappingItem = {
  "@type": string;
  variable: string;
  property: string;
  required: boolean;
};

export type CustomerSearch = {
  "@type": string;
  template: string;
  variableRepresentation: string;
  mapping: CustomerSearchMappingItem[];
};

export type CustomerListResponse = {
  member: CustomerItemData[];
  totalItems: number;
  view: CustomerPagination;
  search: CustomerSearch;
};

export type CustomerPageState = {
  page: number;
  pagination: boolean;
  itemsPerPage?: number;
  name?: string | null;
  address?: string | null;
  reference?: string | null;
  q?: string | null;
  order?: { dataKey: string; order?: "asc" | "desc" };
};

export type CustomerListStateType = {
  pageState: CustomerPageState;
  setPageState: (state: CustomerPageState) => void;
  resetPageState: () => void;
};

export const initialCustomerPageState: CustomerPageState = {
  page: 1,
  itemsPerPage: 10,
  pagination: true,
};
